module.exports = __webpack_public_path__ + "img/desire_001.99109a2.png";